import { Select } from 'antd';

import { formatCreditsShort } from '../shared/billing-format';
import { formatDiscountedUsd } from '../shared/discount';

import type { TopUpPack } from '../shared/packs';

type Props = {
  packs: TopUpPack[];
  value: string;
  onChange: (priceId: string) => void;
  disabled?: boolean;
  testId?: string;
};

export const PackSelect = ({ packs, value, onChange, disabled, testId }: Props) => (
  <Select
    value={value}
    onChange={onChange}
    disabled={disabled}
    data-testid={testId}
    style={{ minWidth: 220 }}
    options={packs.map((pack) => ({
      value: pack.priceId,
      label: `${formatCreditsShort(pack.credits)} credits · ${formatDiscountedUsd(pack.priceCents, pack.discountedPriceCents)}`,
    }))}
  />
);
